<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  
}
</script>

<style lang="less">
html,body,h3,p{
  margin: 0;
  padding: 0;
}
body{
  // overflow: hidden;
  // overflow-x: hidden;
  
  background-color: #f5f5f5
}
#app{
  width: 100%; /* 确保 app 元素宽度为 100% */
}
</style>
